export default "__VITE_ASSET__BxfckpXc__"